module.exports = __webpack_public_path__ + "b89e20eecd847690a34c76c722123700.svg";